///paymentrequest/public/data/
export const GET_PAYMENT_REQUEST_DATA = "GET_PAYMENT_REQUEST_DATA";
export const GET_PAYMENT_REQUEST_DATA_SUCCESS =
  "GET_PAYMENT_REQUEST_DATA_SUCCESS";
export const GET_PAYMENT_REQUEST_DATA_FAILURE =
  "GET_PAYMENT_REQUEST_DATA_FAILURE";
///paymentrequest/public/paymentcomplete
export const GET_PAYMENT_COMPLETE_DATA = "GET_PAYMENT_COMPLETE_DATA";
export const GET_PAYMENT_COMPLETE_DATA_SUCCESS =
  "GET_PAYMENT_COMPLETE_DATA_SUCCESS";
export const GET_PAYMENT_COMPLETE_DATA_FAILURE =
  "GET_PAYMENT_COMPLETE_DATA_FAILURE";
